<template>

    <div class="new-list-group-item new-list-group-item-add">

        <div class="row">
            <div class="col-4">
                <datepicker-new
                    :input-class="{
                        'form-control': true,
                        'form-control-sm': true,
                        'is-invalid': getError('starts_at')
                    }"
                    placeholder="Välj datum"
                    :use-utc="true"
                    :language="former.datepicker.locale"
                    :monday-first="true"
                    :disabled-dates="former.datepicker.disabledDates"
                    :format="formerDateFormat"
                    v-model="period.starts_at"
                />
            </div>
            <div class="col-6" v-if="subscription.type !== 'pay_per_treatment'">
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="monthly_cost"
                    v-model="period.monthly_cost"
                    addon=" kr"
                    customErrorMessage="Ange månadskostnad"
                />
            </div>

            <div class="col-6" v-if="subscription.type !== 'pay_per_treatment' && subscription.type !== 'unlimited'">
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="exceeding_treatment_cost"
                    v-model="period.exceeding_treatment_cost"
                    addon=" kr"
                    customErrorMessage="Ange pris för extra behandlingar"
                />
            </div>

            <div class="col-6" v-if="subscription.type === 'pay_per_treatment'">
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="internal_treatment_cost"
                    v-model="period.internal_treatment_cost"
                    addon=" kr"
                    customErrorMessage="Ange behandlingspris"
                    v-if="subscription.internal === 1"
                />
            </div>
            <div class="col-6" v-if="subscription.type === 'pay_per_treatment'">
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="external_treatment_cost"
                    v-model="period.external_treatment_cost"
                    addon=" kr"
                    customErrorMessage="Ange behandlingspris"
                    v-if="subscription.external === 1"
                />
            </div>
            <div class="col-4" v-if="subscription.external === 1">
                <input-text
                    type="number"
                    formGroupClass="w-75 mb-0"
                    name="monthly_workplace_cost"
                    v-model="period.monthly_workplace_cost"
                    addon=" kr"
                />
            </div>
            <div class="col-4" v-else></div>

            <div class="col d-flex justify-content-end">
                <button class="btn btn-primary btn-sm" :disabled="poster.submitted" @click="posterPost()">
                    <span class="spinner-border spinner-border-sm"></span>
                    Lägg till prisperiod
                </button>
            </div>
        </div>

    </div>

</template>

<script>
import moment from 'moment'

import poster from '../../../../shared/mixins/poster'

export default {

    mixins: [
        poster
    ],

    props: {
        subscription: {
            required: true
        }
    },

    data () {
        return {
            period: {
                starts_at: null,
                monthly_cost: null,
                exceeding_treatment_cost: null,
                internal_treatment_cost: null,
                external_treatment_cost: null,
                monthly_workplace_cost: null
            },
            former: {
                datepicker: {
                    disabledDates: {
                        customPredictor: function (date) {
                            if (moment().isAfter(date)) {
                                return true
                            }

                            if (date.getDate() !== 1) {
                                return true
                            }
                        }
                    }
                }
            }
        }
    },

    computed: {
        posterUrl () {
            return '/subscriptions/' + this.subscription.id + '/pricePeriods'
        },
        posterData () {
            return this.period
        }
    },

    methods: {
        posterSuccess () {
            bus.$emit('notify', 'Prisperiod har lagts till.')
            this.$emit('refresh')
        }
    }
}
</script>
